import {
  ImagesSkuShieldSvg,
  ImagesSkuSpiritoryCheckmarkSvg,
} from '@/assets/images_sku.assets';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { Routes } from '@/types/routes.enum';
import { SkuEnum } from '@/types/translations/SkuEnum';
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { FaMinus, FaPlus } from 'react-icons/fa';

export default function SkuFeatures() {
  const { translate } = useTypedTranslation<SkuEnum>('sku');

  return (
    <>
      <Disclosure>
        {({ open }) => (
          <>
            <DisclosureButton
              className={clsx(
                `
                  tw-w-full tw-flex tw-items-center tw-justify-between tw-bg-transparent tw-border-l-0 tw-border-r-0 tw-border tw-border-[#5F6D7E66] tw-border-solid tw-py-6 tw-transition tw-duration-300 tw-ease-in-out hover:tw-text-main-shades-500
                  focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-main-shades-300 active:tw-opacity-80
                  `,
                open &&
                  'tw-bg-main-shades-300 tw-text-main-shades-900 tw-bg-opacity-50'
              )}
            >
              <div className="tw-flex tw-items-center tw-gap-2 tw-text-textBlack tw-text-lg tw-font-bold tw-font-plusJakartaSans max-nine:tw-text-sm">
                <Image
                  src={ImagesSkuShieldSvg}
                  alt="Checkmark"
                  width={24}
                  height={24}
                />
                {translate(SkuEnum['product.spiritory_buyer_protection'])}
              </div>
              <div className="tw-text-sm nine:tw-text-base">
                {open ? <FaMinus /> : <FaPlus />}
              </div>
            </DisclosureButton>
            <DisclosurePanel
              className="tw-relative tw-p-4 tw-origin-top tw-transition tw-duration-200 tw-ease-out data-[closed]:tw--translate-y-6 data-[closed]:tw-opacity-0 max-nine:tw-text-sm tw-font-plusJakartaSans tw-text-darkblue"
              transition
            >
              {translate(SkuEnum['product.buyer_protection_desc'])}
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
      <Disclosure>
        {({ open }) => (
          <>
            <DisclosureButton
              className={clsx(
                `
                  tw-w-full tw-flex tw-items-center tw-justify-between tw-bg-transparent tw-border-l-0 tw-border-r-0 tw-border-t-0 tw-border tw-border-[#5F6D7E66] tw-border-solid  tw-py-6 tw-transition tw-duration-300 tw-ease-in-out hover:tw-text-main-shades-500
                  focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-main-shades-300 active:tw-opacity-80
                  `,
                open &&
                  'tw-bg-main-shades-300 tw-text-main-shades-900 tw-bg-opacity-50'
              )}
            >
              <div className="tw-flex tw-items-center tw-gap-2 tw-text-textBlack tw-text-lg tw-font-bold tw-font-plusJakartaSans max-nine:tw-text-sm">
                <Image
                  src={ImagesSkuSpiritoryCheckmarkSvg}
                  alt="Checkmark"
                  width={24}
                  height={24}
                />
                {translate(SkuEnum['product.authenticated_by_spiritory'])}
              </div>
              <div className="tw-text-sm nine:tw-text-base">
                {open ? <FaMinus /> : <FaPlus />}
              </div>
            </DisclosureButton>
            <DisclosurePanel
              className="tw-relative tw-p-4 tw-origin-top tw-transition tw-duration-200 tw-ease-out data-[closed]:tw--translate-y-6 data-[closed]:tw-opacity-0 max-nine:tw-text-sm tw-font-plusJakartaSans tw-text-darkblue"
              transition
            >
              {translate(SkuEnum['product.authenticated_desc'])}
              &nbsp;
              <Link
                className="tw-text-main tw-right-0 tw-bottom-0"
                href={Routes._AUTHENTICATING}
              >
                {translate(SkuEnum['product.learn_more'])}
              </Link>
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
    </>
  );
}
